export default "__VITE_ASSET__d3775c0e__"